module.exports = __webpack_public_path__ + "static/media/icon_insight_title.5e46e5a3.svg";